<template>
  <div class="rule-container">
    <div class="center-flex-y" v-for="item in pageData" :key="item.id">
      <div class="divider margin-tb-24">{{ item.name }}</div>
      <ul class="width-full">
        <li
        class="rule-menu-item flex align-center justify-between padding-lr-16 padding-tb-14"
        v-for="iten in item.children"
        :key="iten.id"
        @click="$router.push(iten.path)"
        >
          <div>
            <div class="text-bold">{{ iten.name }}</div>
            <div class="text-grey text-12 margin-top-6">{{ iten.describe }}</div>
          </div>
          <img :src="$dyyy(iten.icon)" width="55" height="55" alt="" srcset="">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageData: [
        {
          id: 1,
          name: '合乘规则',
          children: [
            {
              id: 1,
              name: '顺风车合乘公约',
              describe: '责任明确 合乘更舒适',
              icon: '30',
              path: '/dyyy/rule/convention'
            },
            {
              id: 2,
              name: '顺风车合乘礼仪须知',
              describe: '互助共享 文明合乘',
              icon: '31',
              path: '/dyyy/rule/ceremony'
            }
          ]
        },
        {
          id: 2,
          name: '平台规范',
          children: [
            {
              id: 1,
              name: '用户行为管理规则',
              describe: '规范出行 远离“高压线”',
              icon: '32',
              path: '/dyyy/rule/user'
            },
            {
              id: 2,
              name: '1分钟了解发票',
              describe: '解决有关发票的相关问题',
              icon: '33',
              path: '/dyyy/rule/invoice'
            },
            {
              id: 3,
              name: '高速费用分摊规则',
              describe: '责任明确 分摊更清晰',
              icon: '34',
              path: '/dyyy/rule/road-fee'
            },
            {
              id: 4,
              name: '行程取消判责规则详解',
              describe: '违规取消 可追责',
              icon: '35',
              path: '/dyyy/rule/cancel-trip'
            },
            {
              id: 5,
              name: '顺风车信任分规则详解',
              describe: '做高分用户 一路顺风行',
              icon: '36',
              path: '/dyyy/rule/score'
            },
            {
              id: 6,
              name: '顺风车订单取消率规则',
              describe: '高效履约 优先接单',
              icon: '37',
              path: 'cancel-order'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-container {
  background-color: #fff;
  min-height: 100vh;
  padding: 10px;
}
.divider {
  position: relative;
  color: $grey;
  margin-bottom: 20px;
  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 80px;
    height: 1px;
    background-color: $grey;
    top: 50%;
    transform: scaleY(0.5) translateY(-50%);
  }
  &::before {
    left: -96px;
  }
  &::after {
    right: -96px;
  }
}

.rule-menu-item {
  box-shadow: 0 0 8px 0 $grey3;
  margin-bottom: 14px;
  border-radius: 4;
}
</style>
